import axios from "axios";
import authHeader from "@/services/auth.header";
import { HTTP } from "@/http/config";
import { AnyObject } from "yup";
const API_URL = HTTP.api_url;
class TipoRefService {
  async getIndex(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + "tiporeferidos", { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getSearch(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `tiporeferidos`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getlist(pageNumber): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `tiporeferidos?page=${pageNumber}`, { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }

  async postCreated(tipoRef): Promise<AnyObject> {
    const response = await axios
      .post(API_URL + "tiporeferidos", tipoRef, { headers: authHeader() })
      .then((response) => {
        // console.log(response.data)
        return response.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async postUpdate(id, tipoRef): Promise<AnyObject> {
    const response = await axios
      .put(
        API_URL + `tiporeferidos/${id}`,
        { id: Number(id), ...tipoRef },
        { headers: authHeader() },
      )
      .then((response) => {
        //console.log(response.data)
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }
  async getEdit(id): Promise<AnyObject[]> {
    const response = await axios
      .get(API_URL + `tiporeferidos/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getDelete(id): Promise<AnyObject> {
    const response = await axios
      .delete(API_URL + `tiporeferidos/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getListTipoRef(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + "tiporeferidos/list-tipo", { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  
  async getEstadistica(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `tiporeferidos/chart-estadistica`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  
}
export default new TipoRefService();
